import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
//import Cookies from "universal-cookie";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import {Modal,Button} from 'react-bootstrap';
import Mymodal from "./ModalLogin"
//const cookies = new Cookies();
export default class IncomeTax extends Component {
    constructor(props) {
        super(props);
        this.state = {input:{},
            myitems: [],
            isLoaded: false,
            fromDate: new Date(),
            toDate: new Date(),
            toSDate:"",
            ModalHeading:"",
            isOpen:true
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.closeModal = this.closeModal.bind(this);
        //self = this;
    }
    openModal(e){this.setState({ isOpen: true })}
    closeModal(e){this.setState({ isOpen: false })}

         
    handleSubmit(){
        this.setState({isLoaded:true,ModalHeading:"Error"});
    }
    render(){
        let isLoaded = this.state.isLoaded;
        //window.alert(isLoaded);
        if (isLoaded) 
        {
         return (
             <div className="container1">
                 <Mymodal modalTitle={this.state.ModalHeading} modalBody="Sorry, currently you are not logged in OR your login session has been expired."/>
                </div>
            );
        } 
        else 
        {
            return (

                <div className="container1">
                    
                    <table width="600px" align="center" height="100px">
                        <tr>From: <DatePicker
                            selected={ this.state.fromDate }
                            onChange={ this.handleChange }
                            name="fromDate"
                            dateFormat="dd/MM/yyyy"/></tr>
                        <tr>To: <DatePicker
                            variant="inline"
                            openTo="year"
                            views={["month", "year"]}
                            label="Year and Month"
                            helperText="Start from year selection"
                            value={this.state.toDate}
                            onChange={this.handleChange}
                            dateFormat="MM/yyyy"
                            />
                        </tr>
                        <tr align="right" height="10px">
                            <td colspan="4">
                                <button onClick={this.handleSubmit.bind(this)} align="right" className="btn btn-secondary active"> submit</button>
                            </td>
                        </tr>        
                    </table>
                </div>
            )
        }
    }
}